var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState, useEffect } from 'react';
import { Spin } from '../index';
export var LoadingPosition;
(function (LoadingPosition) {
    LoadingPosition["Left"] = "left";
    LoadingPosition["Center"] = "center";
})(LoadingPosition || (LoadingPosition = {}));
export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection["Vertical"] = "vertical";
    ScrollDirection["Horizontal"] = "horizontal";
})(ScrollDirection || (ScrollDirection = {}));
ScrollList.LoadingPosition = LoadingPosition;
ScrollList.ScrollDirection = ScrollDirection;
export default function ScrollList(props) {
    var render = props.render, dataSource = props.dataSource, wrapperStyle = props.wrapperStyle, onReachBottom = props.onReachBottom, _a = props.maxHeight, maxHeight = _a === void 0 ? 300 : _a, wrapperClassName = props.wrapperClassName, _b = props.loadingConfig, loadingConfig = _b === void 0 ? {} : _b, _c = props.direction, direction = _c === void 0 ? ScrollDirection.Vertical : _c;
    var tip = loadingConfig.tip, icon = loadingConfig.icon, style = loadingConfig.style, _d = loadingConfig.size, size = _d === void 0 ? 28 : _d, className = loadingConfig.className, _e = loadingConfig.position, position = _e === void 0 ? LoadingPosition.Center : _e;
    var containerElement = useRef(null);
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (item) {
            var target = item.target;
            var listItem = target.childNodes[0];
            if (!item.intersectionRatio) {
                listItem.style.display = 'none';
            }
            else {
                if (!target.style.width || !target.style.height) {
                    var _a = getRelElementRect(listItem), width = _a.width, height = _a.height;
                    target.style.width = width + 'px';
                    target.style.height = height + 'px';
                }
                listItem.style.display = 'inherit';
            }
        });
    });
    useEffect(function () {
        var container = (containerElement && containerElement.current);
        [].slice.call(container.childNodes).forEach(function (childNode) { return io.observe(childNode); });
        return function () { return io.disconnect(); };
    }, [dataSource]);
    var childNodes = render(dataSource);
    if (childNodes.find(function (item) { return !item.key; })) {
        console.error('Error: Each child in `ScrollList` must have a "key" prop');
        return null;
    }
    var newChildNodes = childNodes.map(function (node) { return (React.createElement("div", { key: node.key }, node)); });
    function containerScroll() {
        var container = (containerElement && containerElement.current);
        if (container) {
            var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
            var byBottom = (scrollHeight - scrollTop - clientHeight) < 5;
            if (byBottom && !loading) {
                setLoading(true);
                Promise.resolve(onReachBottom()).finally(function () { return setLoading(false); });
            }
        }
    }
    var lengthPixel = maxHeight + 'px';
    var isVertical = direction === ScrollDirection.Vertical;
    var overflowConfig = isVertical
        ? { overflowY: 'scroll', overflowX: 'hidden', maxHeight: lengthPixel, height: lengthPixel }
        : { overflowX: 'scroll', overflowY: 'hidden', maxWidth: lengthPixel, width: lengthPixel };
    return (React.createElement("div", { style: __assign({ position: 'relative' }, (isVertical ? {} : { display: 'flex' })) },
        React.createElement("div", { style: __assign(__assign({}, wrapperStyle), overflowConfig), ref: containerElement, onScroll: containerScroll, className: wrapperClassName }, newChildNodes),
        loading && React.createElement(Spin, { icon: icon, size: size, className: className, style: __assign(__assign({}, style), (isVertical ? {} : {
                display: 'flex',
                alignItems: 'center',
                width: size * 1.5 + 'px',
            })), tip: position === LoadingPosition.Center && !tip ? ' ' : tip })));
}
function getRelElementRect(ele) {
    var result = getComputedStyle(ele);
    var width = result.width, height = result.height, boxSizing = result.boxSizing, borderWidth = result.borderWidth, marginTop = result.marginTop, marginLeft = result.marginLeft, marginRight = result.marginRight, marginBottom = result.marginBottom, paddingTop = result.paddingTop, paddingLeft = result.paddingLeft, paddingRight = result.paddingRight, paddingBottom = result.paddingBottom;
    var realWidth = parseFloat(width) +
        parseFloat(borderWidth) +
        parseFloat(marginLeft) +
        parseFloat(marginRight) +
        parseFloat(paddingLeft) +
        parseFloat(paddingRight);
    var realHeight = parseFloat(height) +
        parseFloat(borderWidth) +
        parseFloat(marginTop) +
        parseFloat(marginBottom) +
        parseFloat(paddingTop) +
        parseFloat(paddingBottom);
    if (boxSizing === 'border-box') {
        realWidth -=
            parseFloat(borderWidth) +
                parseFloat(paddingLeft) +
                parseFloat(paddingRight);
        realHeight -=
            parseFloat(borderWidth) +
                parseFloat(paddingTop) +
                parseFloat(paddingBottom);
    }
    return {
        width: realWidth,
        height: realHeight,
    };
}
//# sourceMappingURL=index.js.map